<template>
  <div>
    <div class="mb-4 mt-2 sub">{{ title }}</div>
    <router-link :to="targetPath"
      ><img :src="image" style="width: 400px; max-width: 100%"
    /></router-link>
    <br /><v-btn class="mt-2" :to="targetPath" color="info"
      >Check it out!</v-btn
    >
  </div>
</template>

<script>
export default {
  name: "MusicHighlight",
  props: {
    title: String,
    image: String,
    targetPath: String
  },
  components: {
  },
};
</script>

<style>
.sub {
  font-size: 18px;
}
</style>